import React from "react";
import LanguageSwitcher from "../components/LanguageSwitcher";

/**
 * Shared full-screen loading state displayed while auth/profile data is loading.
 * Used by Dashboard, EditProfile, History, etc.
 */
export function LoadingScreen({ language, setLanguage }) {
    return (
        <div className="flex h-screen bg-slate-100 dark:bg-dashboard-bg text-black dark:text-white font-sans">
            <LanguageSwitcher language={language} setLanguage={setLanguage} />
            <div className="flex-1 flex flex-col gap-8 items-center justify-center -mt-36">
                <div className="flex flex-col gap-4 items-center text-center">
                    <div className="flex items-center gap-2">
                        <div className="flex gap-1">
                            <div className="w-3 h-3 bg-orange-500 rounded-full animate-bounce" />
                            <div
                                className="w-3 h-3 bg-orange-500 rounded-full animate-bounce"
                                style={{ animationDelay: "0.1s" }}
                            />
                            <div
                                className="w-3 h-3 bg-orange-500 rounded-full animate-bounce"
                                style={{ animationDelay: "0.2s" }}
                            />
                        </div>
                        <span className="text-orange-500 text-lg font-semibold">
                            {language === "zh"
                                ? "正在加載數據..."
                                : "Loading data..."}
                        </span>
                    </div>
                    <div className="text-sm text-gray-600 dark:text-gray-400">
                        {language === "zh"
                            ? "請稍候，正在為您準備個人資料面板。"
                            : "Please wait while we prepare your profile panel."}
                    </div>
                </div>
            </div>
        </div>
    );
}
